import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";
import { HTTP } from "@/http-common";
import AuthService from "@/Auth/AuthService";
import router from "@/router";
import * as LDClient from "launchdarkly-js-client-sdk";
const auth = new AuthService();

const { login, logout, authenticated, authNotifier, passwordLogin } = auth;

const state = {
  token: null,
  isAuthenticated: false,
  userProfile: null,
  expiresAt: null
};

const getters = {
  isAuthenticated: state => !!state.token,
  token: state => (state.token ? state.token.idToken : null),
  getField
};

const actions = {
  reset: ({ commit }) => {
    commit("clear_auth_tokens");
  },
  logout: ({ commit }) => {
    return new Promise(() => {
      auth.logout();
      commit("clear_auth_tokens");
      router.push("/login");
    });
  },
  login: () => {
    return new Promise(resolve => {
      auth.login();
      resolve();
    });
  },
  passwordReset: ({ dispatch }, employee) => {
    return new Promise((resolve, reject) => {
      HTTP.post("/dealerportal/resetAuth0Password", {
        email: employee.email
      })
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({ message: data.data.message, httpStatus: 200 }),
            { root: true }
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({ message: err.message, httpStatus: 500 }),
            { root: true }
          );
          reject(err);
        });
    });
  },
  passwordLogin: ({ dispatch }, { username, password }) => {
    return new Promise((resolve, reject) => {
      auth
        .passwordLogin({ username, password })
        .then(() => {
          resolve();
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({ message: err.error_description, httpStatus: 500 }),
            { root: true }
          );
          reject(err);
        });
    });
  },
  handleAuthentication: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      auth
        .handleAuthentication()
        .then(authResult => {
          const user = {
            key: authResult.idTokenPayload.email
          };

          const client = LDClient.initialize(process.env.LAUNCHDARKLY, user);

          client.on("ready", function () {
            dispatch("featureFlag/setAllFlags", client.allFlags(), {
              root: true
            });
          });

          client.on("change", function () {
            dispatch("featureFlag/setAllFlags", client.allFlags(), {
              root: true
            });
          });

          commit("update_auth_tokens", authResult);
          resolve(true);
        })
        .catch(err => {
          commit("clear_auth_tokens");
          reject(err);
        });
    });
  },
  checkAuthLevel: async ({ dispatch }) => {
    var authDealer = await HTTP.get("api/Impersonate/GetDealerAuthAsync/4")
    if (authDealer.data.authLevel !== "Admin") {
      dispatch(
        "message/setMessage",
        new httpError({ message: "Only Administrator can login to this application", httpStatus: 500 }),
        { root: true }
      );
      dispatch('logout')
      return false;
    }
    return true
  },
  addMFAToUser({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(`api/Auth/AddMFAToUser`, { email });
      response
        .then((data) => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: 'User enrolled in MFA',
              httpStatus: 200
            }),
            { root: true }
          );
          resolve('ok');
        })
        .catch((err) => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: 'Request Failed: ' + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(err.message);
        });
    });
  },

};

const mutations = {
  clear_auth_tokens(state) {
    state.token = null;
    state.userProfile = null;
    state.expiresAt = null;
  },
  update_auth_tokens(state, authResult) {
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    state.token = authResult;
    state.userProfile = authResult.idTokenPayload;
    state.expiresAt = expiresAt;
    HTTP.defaults.headers.common["Authorization"] =
      "Bearer " + authResult.idToken;
  },
  update_current_user(state, user) {
    state.currentUser = user;
  },

  updateField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
